import { render, staticRenderFns } from "./AssistantServiceCreate.vue?vue&type=template&id=cd2aaa72"
import script from "./AssistantServiceCreate.vue?vue&type=script&lang=js"
export * from "./AssistantServiceCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports